import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core'
import { TaskProgress, TaskProgressFromJSON } from 'elements-sdk'

import { TasksService, TaskState } from '../services/tasks.service'
import { BaseComponent } from 'common/helpers'
import { SocketService } from 'common/util/module'

@Component({
  selector: 'task-state-badge',
  templateUrl: './taskStateBadge.component.pug',
  styleUrls: ['./taskStateBadge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskStateBadgeComponent extends BaseComponent {
  @Input() id: string
  @Input() state: number
  @Input() progress: TaskProgress|null

  constructor (
    private tasks: TasksService,
    cdr: ChangeDetectorRef,
    socket: SocketService,
  ) {
    super()
    this.subs.add(socket.subject('tasks:progress').subscribe(data => {
      if (this.id === data.id) {
        this.progress = TaskProgressFromJSON(data.progress)
        cdr.markForCheck()
      }
    }))
  }

  get stateClass (): string {
    const style = {
      [TaskState.RUNNING]: 'info',
      [TaskState.PENDING]: 'warning',
      [TaskState.ABORTING]: 'warning',
      [TaskState.FINISHED]: 'success',
      [TaskState.NOOP]: 'success',
      [TaskState.WARNINGS]: 'warning',
      [TaskState.FAILED]: 'danger',
      [TaskState.ABORTED]: 'danger',
    }[this.state] ?? ''

    return `badge badge-${style}`
  }

  get stateIcon (): string {
    return {
      [TaskState.PENDING]: 'fa-clock',
      [TaskState.RUNNING]: 'fa-play',
      [TaskState.ABORTING]: 'fa-spin fa-circle-notch',
      [TaskState.FINISHED]: 'fa-check',
      [TaskState.NOOP]: 'fa-check',
      [TaskState.WARNINGS]: 'fa-exclamation-triangle',
      [TaskState.FAILED]: 'fa-times',
      [TaskState.ABORTED]: 'fa-times',
    }[this.state] ?? ''
  }

  get stateText (): string {
    return this.tasks.taskStateNames[this.state] ?? this.tasks.taskStateNames[TaskState.PENDING]
  }

  get progressPercent (): number {
    const current = this.progress?.current ?? 0
    const max = this.progress?.max || 1 // eslint-disable-line @typescript-eslint/prefer-nullish-coalescing
    return this.progress?.bar ? 100 * current / max : 100
  }
}
